// GuidesLayout.js
// Lightweight chrome shared by GuidesIndex and GuideArticle: a slim top bar
// with the TTO wordmark (links home) and a content container. Kept minimal so
// it reads as the same site without re-importing the full landing header.
//
// Styling: inline styles + the shared `colors` token, matching LandingPage.js
// (CLAUDE Rule 8). Fonts assume 'DM Serif Display' (display) and the site's
// default sans body font are already loaded globally by the app, as they are
// on the landing page.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import SpaLink from '../SpaLink';
import { colors } from './guidesData';

export default function GuidesLayout({ children, maxWidth = 760 }) {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: colors.gray50, color: colors.gray800 }}>
      {/* Slim top bar */}
      <header
        style={{
          background: 'white',
          borderBottom: `1px solid ${colors.gray200}`,
          padding: '12px 20px',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'baseline', gap: 10 }}
          >
            <span
              style={{
                fontSize: 20,
                fontWeight: 800,
                color: colors.gray900,
                letterSpacing: '-0.5px',
              }}
            >
              Tee Time Organizer
            </span>
            <span style={{ fontSize: 12, color: colors.gray500, fontWeight: 500 }}>Guides</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Nov 1, 2026 (Dennis): a clear way back to the home page from Guides. */}
          <SpaLink
            to="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              minHeight: 40,
              padding: '0 14px',
              border: `1px solid ${colors.gray200}`,
              borderRadius: 8,
              background: 'white',
              color: colors.gray700,
              fontSize: 14,
              fontWeight: 700,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}
          >
            ← Home
          </SpaLink>
          <button
            onClick={() => navigate('/register?tier=free')}
            style={{
              background: `linear-gradient(135deg, ${colors.green700} 0%, ${colors.green900} 100%)`,
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '9px 16px',
              fontSize: 14,
              fontWeight: 700,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            Try it free
          </button>
          </div>
        </div>
      </header>

      {/* Content container */}
      <main style={{ maxWidth, margin: '0 auto', padding: '32px 20px 64px' }}>{children}</main>

      {/* Slim footer with back-home + privacy, mirroring landing footer links */}
      <footer
        style={{
          background: colors.gray900,
          color: colors.gray300,
          padding: '28px 20px',
          textAlign: 'center',
          fontSize: 13,
        }}
      >
        <div style={{ marginBottom: 10 }}>
          <span
            onClick={() => navigate('/')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            Home
          </span>
          <span
            onClick={() => navigate('/guides')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            All Guides
          </span>
          <span
            onClick={() => navigate('/privacy')}
            style={{ color: colors.gray300, cursor: 'pointer', margin: '0 10px' }}
          >
            Privacy
          </span>
        </div>
        <div style={{ color: colors.gray500 }}>
          © 2025–2026 Tee Time Organizer. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
